module.exports = __webpack_public_path__ + "static/img/cp1.831525a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp1.png
// module id = gXaP
// module chunks = 0